import React, { useState } from 'react';
import { Box, Typography, Tabs, Tab, Paper, Chip, Alert, Button } from '@mui/material';
import {
  List as ListIcon, Visibility as WatchIcon, Extension as ExtensionIcon,
  Palette as PaletteIcon, ArrowForward as ArrowForwardIcon,
  PhoneIphone as PhoneIcon, Android as AndroidIcon,
  GridView as GridViewIcon,
} from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import ScriptsListMockup from './ScriptsListMockup';
import WatchModeMockup from './WatchModeMockup';
import ExtensionModeMockup from './ExtensionModeMockup';
import ContentFilteringMockup from './ContentFilteringMockup';

const MockupIndex = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box sx={{ maxWidth: '100%', mx: 'auto' }}>
      {/* Header */}
      <Box sx={{ mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
          <PaletteIcon sx={{ fontSize: 28, color: '#1976d2' }} />
          <Typography variant="h4" fontWeight={700}>
            Unified Script Editor
          </Typography>
          <Chip label="MOCKUP" size="small" color="warning" sx={{ fontWeight: 700 }} />
        </Box>
        <Typography variant="body1" color="text.secondary">
          Interactive design mockups for the Automatrix Script Editor. These pages use hardcoded data for review purposes.
        </Typography>
      </Box>

      {/* PRIMARY — Unified all-mocks landing */}
      <Alert
        severity="success"
        icon={<GridViewIcon />}
        sx={{
          mb: 2, bgcolor: '#f5f9ff', color: '#0d47a1',
          borderLeft: '4px solid #1976d2',
          '& .MuiAlert-icon': { color: '#1976d2' },
        }}
        action={
          <Button
            component={RouterLink}
            to="/mockups/all"
            variant="contained"
            size="small"
            endIcon={<ArrowForwardIcon />}
            sx={{ textTransform: 'none', fontWeight: 700 }}
          >
            Open unified gallery
          </Button>
        }
      >
        <strong>Morning-review packet:</strong> start here — <code>/mockups/all</code> shows
        every Dashboard · Ext v5 · Android · iOS mock under one narrative
        (Jaden Martinez · 8th Grade American Government · Five Keys).
      </Alert>

      {/* Extension v5 callout */}
      <Alert
        severity="info"
        icon={<ExtensionIcon />}
        sx={{ mb: 2, bgcolor: '#faf7fd', color: '#4a148c', borderLeft: '4px solid #7b1fa2' }}
        action={
          <Button
            component={RouterLink}
            to="/mockups/ext-v5"
            size="small"
            endIcon={<ArrowForwardIcon />}
            sx={{ textTransform: 'none', color: '#7b1fa2', fontWeight: 700 }}
          >
            Open Extension v5 Mocks
          </Button>
        }
      >
        <strong>Extension v5 UI mockups</strong> — sidebar / recording / agent mode / first run.
        See <code>/mockups/ext-v5</code>.
      </Alert>

      {/* iOS port callout */}
      <Alert
        severity="info"
        icon={<PhoneIcon />}
        sx={{ mb: 2, bgcolor: '#f5f9ff', color: '#0d47a1', borderLeft: '4px solid #1976d2' }}
        action={
          <Button
            component={RouterLink}
            to="/mockups/ios"
            size="small"
            endIcon={<ArrowForwardIcon />}
            sx={{ textTransform: 'none', color: '#1976d2', fontWeight: 700 }}
          >
            Open iOS Mocks
          </Button>
        }
      >
        <strong>AchieveDXP iOS port mockups</strong> — login · dashboard · partner launch · progress · join class · profile.
        See <code>/mockups/ios</code>.
      </Alert>

      {/* Android port callout */}
      <Alert
        severity="info"
        icon={<AndroidIcon />}
        sx={{ mb: 2, bgcolor: '#f1faf2', color: '#1b5e20', borderLeft: '4px solid #3ddc84' }}
        action={
          <Button
            component={RouterLink}
            to="/mockups/android"
            size="small"
            endIcon={<ArrowForwardIcon />}
            sx={{ textTransform: 'none', color: '#2e7d32', fontWeight: 700 }}
          >
            Open Android Mocks
          </Button>
        }
      >
        <strong>AchieveDXP Android port mockups</strong> — login · dashboard · partner launch · progress · join class · profile.
        See <code>/mockups/android</code>.
      </Alert>

      {/* Tab navigation */}
      <Paper sx={{ mb: 3 }} elevation={1}>
        <Tabs
          value={activeTab}
          onChange={(_, v) => setActiveTab(v)}
          sx={{
            '& .MuiTab-root': {
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '0.95rem',
              minHeight: 56,
            },
          }}
        >
          <Tab icon={<ListIcon />} iconPosition="start" label="Scripts List" />
          <Tab icon={<WatchIcon />} iconPosition="start" label="Watch Mode (CDP)" />
          <Tab icon={<ExtensionIcon />} iconPosition="start" label="Extension Mode" />
          <Tab icon={<PaletteIcon />} iconPosition="start" label="Content Filtering" />
        </Tabs>
      </Paper>

      {/* Tab content */}
      <Box>
        {activeTab === 0 && <ScriptsListMockup />}
        {activeTab === 1 && <WatchModeMockup />}
        {activeTab === 2 && <ExtensionModeMockup />}
        {activeTab === 3 && <ContentFilteringMockup />}
      </Box>
    </Box>
  );
};

export default MockupIndex;
